/**
 * Detect iOS devices (Bug #9 fix)
 * iOS prevents programmatic volume control, so we hide volume UI
 */
export function isIOS() {
  // Check userAgent for iPhone, iPad, iPod
  const userAgent = window.navigator.userAgent.toLowerCase();
  const isIOSUserAgent = /iphone|ipad|ipod/.test(userAgent);

  // Check for iPad Pro (reports as MacIntel but has touch)
  const isMacTouch =
    navigator.platform === 'MacIntel' &&
    navigator.maxTouchPoints > 0;

  return isIOSUserAgent || isMacTouch;
}
